import React, { Component } from 'react';
import { Menu, Dropdown, Icon, Button, Col, Select } from 'antd';
import SvgIcon from 'SvgIcon';
import { openDB, IDB_searchData, IDB_saveData, IDB_deleteOneData } from 'yxyweb/common/redux/indexedDB'
import _ from 'lodash'

// let sortDraftdata = [];

export default class Draftbutton extends React.Component {
  constructor(props) {
    super(props);
    let isIpad = cb.rest.terminalType == 2 ? true : false;
    this.openIndexdb();//打开数据库
    let controls = this.props.controls
    this.viewModel = props.model.getParent();
    const status = this.viewModel.getParams().mode//获取当前状态
    let userId = cb.rest.AppContext.user.id;
    let billNo = this.viewModel.getParams().billNo;//获取当前单据
    this.state = {
      status: status,
      bEnder: false,
      key: null,
      userId: userId,
      billNo: billNo,
      controls: controls,
      sortDraftdata: [],
      isIpad: isIpad
    }
  }
  componentDidMount() {
    this.props.model.addListener(this);
    let _self = this;
    this.viewModel.on('afterSave', function (args) {
      if (args.err == null) {
        let { key } = _self.state;
        // let key = this.viewModel.getCache('draftInfo');
        // let keyValue = key.attrKey
        _self.deleteDraft(key, null)
      }
    });
  }
  componentWillUnmount() {
    this.props.model.removeListener(this);
  }
  setVisible(visible) {
    this.setState({ visible });
    if (this.props.onVisibleChange)
      this.props.onVisibleChange(visible);
  }
  render() {
    if (!this.state.visible)
      return null;
    let draftTag = null;
    let isStyle = this.props.iStyle
    let value = this.props.value;
    let { status, sortDraftdata } = this.state;
    let menuItem = this.menurender();
    const menu = (<Menu overlayClassName="draft_menu" >{menuItem}</Menu>);
    if (status == "add") {
      if (isStyle == 0) {
        draftTag = <Button className="draft_header"><SvgIcon type='caogaoxiang'></SvgIcon>{value}</Button>;
      }
      else {
        draftTag = isStyle == 2 ? <Button className="draft_header"><SvgIcon type='caogaoxiang'></SvgIcon></Button> : <Button className="draft_header">{value}</Button>;
      }

    }
    if (status == "browse") {
      draftTag = <Button className="draf_button  no-border-radius ">{value} <Icon type="down" /></Button>;
    }
    if (!draftTag) return null;
    return (<Dropdown overlayClassName="drop_menu" onVisibleChange={() => this.visibleChange()} overlay={menu}>{draftTag}</Dropdown>);
  }
  visibleChange() {
    this.openIndexdb();
  }
  //排序
  compare(property) {
    return function (a, b) {
      var value1 = a[property];
      var value2 = b[property];
      return value2 - value1;
    }
  }
  gainbillNodata() {
    let options = { dbTableName: 'billNodata' };
    //搜索数据库中数据
    IDB_searchData(options)
      .then(dbData => {
        this.renderData(dbData);
      })
      .catch(e => {
        console.error(e.message);
        return null;
      })
  }
  openIndexdb() {
    return openDB('off-lineDB', cb.rest._dbVersion, ['billNodata'])
      .then(result => {
        if (result) {
          this.gainbillNodata();
        }
        else cb.utils.alert('打开数据库失败，缓存功能不可用！', 'error')
      })
      .catch(e => {
        console.error(e)
      })
  }
  //获取数据后进行整理
  renderData(data) {
    let { sortDraftdata, userId, billNo } = this.state;
    console.log('userId', userId)
    console.log('billNo', billNo)
    let selectValue = userId + '_' + billNo;//当前页的数据标识
    let selectData = [];
    data.forEach(function (ele, index) {
      if (ele.checkKey === selectValue) {
        selectData.push(ele)
      }
    })
    let sortData = selectData.sort(this.compare('copyTime'))
    sortDraftdata = _.slice(sortData, 0, 15)
    this.setState({ sortDraftdata: sortDraftdata })
  }

  //下拉
  menurender() {
    let menuItem = [];
    let self = this;
    let { sortDraftdata, isIpad } = this.state;
    if (sortDraftdata && sortDraftdata.length > 0) {
      sortDraftdata.forEach(function (ele, index) {
        if (isIpad) {
          let enterShow = <span onClick={() => this.deleteDraft(ele.attrKey, true)} className="draft_font"><Icon type='shanchu1'></Icon></span>
          let Item = (<Menu.Item className="draft_menuItem draft_lipc" key={ele.copyTime}
          // onMouseEnter={(e) => self.IsEnterSchemeitem(true, ele.copyTime, sortDraftdata,e)}
          // onMouseLeave={(e) => self.IsEnterSchemeitem(false, ele.copyTime, sortDraftdata,e)}
          >
            {<span className="draft_itemName" readOnly style={{ border: '0', background: 'transparent' }} onClick={() => this.enterDetails(ele)}>{ele.draftName}</span>}
            {<span className="draft_shoutime">{ele.showtime}</span>}
            {enterShow}
          </Menu.Item>)
          menuItem.push(Item);
        }
        else {
          let enterShow = <span onClick={() => this.deleteDraft(ele.attrKey, true)} className="draft_font"><Icon type='shanchu1'></Icon></span>;

          let Item = (<Menu.Item className="draft_menuItem draft_lipc" key={ele.copyTime}
          // onMouseEnter={(e) => self.IsEnterSchemeitem(true, ele.copyTime, sortDraftdata,e)}
          // onMouseLeave={(e) => self.IsEnterSchemeitem(false, ele.copyTime, sortDraftdata,e)}
          >
            {<span className="draft_itemName draft_pc" readOnly style={{ border: '0', background: 'transparent' }} onClick={() => this.enterDetails(ele)}>{ele.draftName}</span>}
            {enterShow}
          </Menu.Item>)

          menuItem.push(Item);

        }

      }, this)
    }
    else { menuItem = (<Menu.Item className="draft_haveNodata">暂无数据</Menu.Item>) }
    return menuItem;
  }
  //进入详情
  enterDetails(ele) {
    this.viewModel.setCache('draftInfo', { attrKey: ele.attrKey })
    this.viewModel.getParams().mode = ele.savedraftstate
    this.viewModel.biz.do('load', this.viewModel, {
      data: ele
    });
    this.setState({ status: ele.savedraftstate, key: ele.attrKey })
  }
  //删除
  deleteDraft(key, isMouseEnter) {
    let options = { id: key, dbTableName: 'billNodata' }
    IDB_deleteOneData(options)
      .then(result => {
        if (isMouseEnter != null) {
          cb.utils.alert('删除草稿成功', 'success')
        }
      })
      .catch(e => {
        cb.utils.alert('删除草稿失败！', 'error');
        console.error(e.message);
        return null;
      })
    this.setState({ bEnder: true })
  }
  // IsEnterSchemeitem(bEnder, copyTime, sortData, e) {
  //   let seft = this
  //   sortData.forEach(function (ele, index) {
  //     if (ele.copyTime == copyTime) {
  //       ele.isMouseEnter = bEnder
  //       seft.setState({ bEnder: bEnder })
  //     }
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/Draftbutton.jsx